import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { v4 as uuidv4 } from 'uuid';
import { FormAnswerDTO } from '../report-filters.dto';

@Component({
  selector: 'app-form-answer-select',
  templateUrl: './form-answer-select.component.html',
  styleUrls: ['./form-answer-select.component.scss'],
  standalone: false,
})
export class FormAnswerSelectComponent implements OnChanges {
  labelId = uuidv4();

  model: FormAnswerDTO;

  internalSelectedAnswerList: FormAnswerDTO[] = [];

  @ViewChild('select') select: NgSelectComponent;

  @Input() label = 'Select answers to filter';

  @Input() answers: FormAnswerDTO[] = [];

  @Input() defaultAnswers: FormAnswerDTO[] = [];

  @Output() readonly selectedAnswerList: EventEmitter<FormAnswerDTO[]> =
    new EventEmitter();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['answers']) {
      this.internalSelectedAnswerList = this.answers.filter((answer) =>
        this.defaultAnswers.find((def) => def.id === answer.id)
      );
    }
  }

  reset() {
    this.internalSelectedAnswerList = [];
    this.select.selectedItems.forEach((item) => {
      this.select.unselect(item);
    });
  }

  answerSelected(answer: FormAnswerDTO) {
    if (answer) {
      if (!this.internalSelectedAnswerList.includes(answer)) {
        this.internalSelectedAnswerList.push(answer);
      }
      this.select.handleClearClick();
      this.outputAnswers();
    }
  }

  outputAnswers() {
    this.selectedAnswerList.emit(this.internalSelectedAnswerList);
  }

  removeAnswerFromList(answer: FormAnswerDTO) {
    this.internalSelectedAnswerList = this.internalSelectedAnswerList.filter(
      (a) => a.id !== answer.id
    );
    this.outputAnswers();
  }
}
